import { HttpError } from '@euler/lib/request/HttpError';
import { BiDraftDetail } from '@euler/model/bi/draft';
import { BiService } from '@euler/services/bi.service';
import { kBiDraftFixtures } from './biDraftFixtures';

export const kExpiredFixtureDraftId = `bidraft_${'expired'.padEnd(26, '0')}`;
export const kLoadingFixtureDraftId = `bidraft_${'loading'.padEnd(26, '0')}`;

/** Serves the fixture drafts, so the widget renders without a server. */
export class FixtureBiService extends BiService {
  constructor() {
    super(null as never);
  }
  async draft(draftId: string): Promise<BiDraftDetail> {
    if (draftId === kLoadingFixtureDraftId)
      return await new Promise<never>(() => undefined);
    const draft = kBiDraftFixtures.find(entry => entry.id === draftId);
    if (draft) return { ...draft, addedTo: [] };
    const error = new HttpError(
      draftId === kExpiredFixtureDraftId
        ? '这张图表已过期，请重新提问生成。'
        : '记录不存在!',
    );
    error.code =
      draftId === kExpiredFixtureDraftId
        ? 'invalid_operation'
        : 'resource_not_found';
    error.subCode =
      draftId === kExpiredFixtureDraftId
        ? 'bi_draft_expired'
        : 'record_not_found';
    throw error;
  }
}
